(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs-collection"] && !Shopify.designMode) return;
  try {
    
// 简化的Tab切换逻辑 - 只处理显示隐藏
document.addEventListener('DOMContentLoaded', function() {
// 获取所有tab按钮和内容
const tabButtons = document.querySelectorAll('[data-t4s-tab-item]');
const tabContents = document.querySelectorAll('[data-t4s-tab-content]');
// 为每个tab按钮绑定点击事件
tabButtons.forEach(button => {
button.addEventListener('click', function(e) {
e.preventDefault();
// 1. 移除所有按钮的激活状态
tabButtons.forEach(btn => btn.classList.remove('t4s-active'));
// 2. 给当前点击的按钮添加激活状态
this.classList.add('t4s-active');
// 3. 获取目标内容ID
const targetId = this.getAttribute('href').substring(1);
// 4. 隐藏所有内容
tabContents.forEach(content => content.classList.remove('t4s-active'));
// 5. 显示目标内容
const targetContent = document.getElementById(targetId);
if (targetContent) {
targetContent.classList.add('t4s-active');
}
});
});
});

  } catch(e) { console.error(e); }
})();
})();
